const ENDS_SENTENCE = /[.!?…]$/;

export const joinDetail = (segments: string[]): string =>
  segments.reduce((joined, segment) => {
    if (!joined) return segment;
    return `${joined}${ENDS_SENTENCE.test(joined.trimEnd()) ? " " : ". "}${segment}`;
  }, "");
